import { getViewport } from '@nova/utils'

document.addEventListener('DOMContentLoaded', () => {
  const $productCarousels = document.querySelectorAll(
    '.js-product-carousel-carousel',
  )

  if ($productCarousels.length === 0) return

  updateProductCarouselAttribute()

  function updateProductCarouselAttribute() {
    productCarouselSizeEvent($productCarousels)

    for (const $carousel of $productCarousels) {
      const $navBtns = $carousel.shadowRoot.querySelectorAll(
        '.carousel__navigation-button',
      )
      initProductCarouselNavBtns($navBtns)
      observeProductCarouselNavBtns($navBtns)
      initProgressBar($carousel)

      // Rehydrate product cards when carousel is initialized
      rehydrateProductCards($carousel)

      const viewport = getViewport()
      switch (viewport) {
        case 'small-mobile':
        case 'mobile':
          // Use 1.32 slides-per-page to match the slide width of the design
          $carousel.setAttribute('slides-per-page', 1.32)
          break
        case 'tablet':
          $carousel.setAttribute('slides-per-page', 2)
          break
        case 'desktop':
          $carousel.setAttribute('slides-per-page', 4)
          break
        case 'large-desktop':
          $carousel.setAttribute('slides-per-page', 4)
          break
        default:
          $carousel.setAttribute('slides-per-page', 4)
          break
      }

      // Listen for slide changes to rehydrate any new cards
      $carousel.addEventListener('sl-slide-change', () => {
        // Small delay to ensure DOM has been updated
        setTimeout(() => {
          rehydrateProductCards($carousel)
        }, 100)
      })
    }
  }

  window.addEventListener('nova:resize-width', updateProductCarouselAttribute)
})

// Function to rehydrate product cards with their variant data
const rehydrateProductCards = (carousel) => {
  if (!window.productCardData || !window.hydrateProductCard) return

  const productCards = carousel.querySelectorAll('nova-product-card[data-product-id]')
  productCards.forEach(card => {
    const productId = card.getAttribute('data-product-id')
    const data = window.productCardData[productId]
    if (data && card.variants.length === 0) {
      card.variants = data.variants
      card.swatches = data.swatches
      card.sizes = data.sizes
      if (data.variants.length === 1) {
        card.showAddButton = true
        card.activeVariant = data.variants[0]
      }
    }
  })
}

const productCarouselSizeEvent = (carousels) => {
  for (const carousel of carousels) {
    const $carouselBase = carousel.shadowRoot.querySelector('#scroll-container')
    const $carouselBtns = carousel.shadowRoot.querySelectorAll(
      '.carousel__navigation-button',
    )
    if ($carouselBtns.length === 0 || !$carouselBase) return
    if (window.innerWidth < 768) return

    for (const $button of $carouselBtns) {
      $button.style.display =
        $carouselBase.scrollWidth > $carouselBase.clientWidth ? 'flex' : 'none'
    }
  }
}

const observeProductCarouselNavBtns = (buttons) => {
  const observerCallback = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class'
      ) {
        const targetElement = mutation.target
        targetElement.style.opacity = targetElement.classList.contains(
          'carousel__navigation-button--disabled',
        )
          ? 0
          : 1
        targetElement.style.cursor = targetElement.classList.contains(
          'carousel__navigation-button--disabled',
        )
          ? 'default'
          : 'pointer'
      }
    }
  }
  const observerConfig = { attributes: true, attributeFilter: ['class'] }
  const observer = new MutationObserver(observerCallback)
  for (const button of buttons) {
    observer.observe(button, observerConfig)
  }
}

const initProductCarouselNavBtns = (buttons) => {
  for (const button of buttons) {
    button.style.opacity = button.classList.contains(
      'carousel__navigation-button--disabled',
    )
      ? 0
      : 1
    button.style.cursor = button.classList.contains(
      'carousel__navigation-button--disabled',
    )
      ? 'default'
      : 'pointer'
  }
}

const initProgressBar = (carousel) => {
  const $progressFill = carousel.parentElement.querySelector('.product-carousel__progress-fill')
  const $totalSlides = carousel.parentElement.querySelector('.product-carousel__total-slides')

  if (!$progressFill || !$totalSlides) return

  const totalSlides = parseInt($totalSlides.value)
  const slidesPerPage = Math.max(1, Math.floor(carousel.clientWidth / carousel.querySelector('sl-carousel-item').clientWidth))
  const totalPages = Math.ceil(totalSlides / slidesPerPage)

  carousel.addEventListener('sl-slide-change', (event) => {
    const currentPage = Math.ceil((event.detail.index + 1) / slidesPerPage)
    const progressPercentage = (currentPage / totalPages) * 100

    $progressFill.style.width = `${progressPercentage}%`
  })

  $progressFill.style.width = `${(1 / totalPages) * 100}%`
}
